import React, { useContext, useRef, useState } from 'react';
import { useApolloClient, useMutation } from '@apollo/react-hooks';
import ls from 'local-storage';
import { navigate } from '@reach/router';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

import { getAppTokenName } from '@squirrellearningltd/go-shared-utils';
import { FormErrors, Button, Modal } from '@squirrellearningltd/go-teacher-components';

import { AuthContext } from '../../services/user/AuthProvider';
import { FRANCHISE_LOGIN } from './services/graphql';
import ForgotPassword from './scenes/ForgotPassword';
import { APP_NAME } from '../../services/constants';

const FranchiseLogin = () => {

    const [formErrors, setFormErrors] = useState([]);
    const client = useApolloClient();
    const auth = useContext(AuthContext);

    const [modalForgotPass, setModalForgotPass] = useState(false);


    const submitting = useRef(false);
    const [login, { loading: loggingIn }] = useMutation(FRANCHISE_LOGIN);

    const schema = Yup.object().shape({
        email: Yup.string().trim().email('Please enter a valid email address')
            .required('Please enter your email'),
        password: Yup.string()
            .required('Please enter your password')
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: schema,
        mode: "onBlur"
    });

    const onSubmit = values => {
        if (submitting.current) return;
        submitting.current = true;
        setFormErrors([]);
        login({ variables: { email: values.email.trim(), password: values.password } }).then(({ data }) => {
            const result = data && data.franchiseLogIn;
            if (result && result.errors && result.errors.length) {
                submitting.current = false;
                setFormErrors(result.errors);
                return;
            }
            if (!result || !result.user || !result.user.id || !result.token || !result.franchise || !result.franchise.id) {
                submitting.current = false;
                setFormErrors(['Unable to log in to the franchise. Please try again.']);
                return;
            }
            ls(getAppTokenName(APP_NAME), result.token);
            auth.setCurrentUser(result.user);
            client.writeData({ data: { loggedIn: true, forcedLogout: false } });
            return navigate(`/franchise-portal/${result.franchise.id}`, { replace: true });
        }).catch(error => {
            submitting.current = false;
            setFormErrors([error.message]);
        });
    };

    return (
        <div className="login u-m-top-3">
            <h1 className="u-m-base-3">Login</h1>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="basic-form__group">
                    <input
                        name="email"
                        placeholder="Email"
                        className="basic-form__text-box"
                        ref={register}
                        type="email"
                        disabled={loggingIn}
                    />
                </div>
                {errors.email && <p className="basic-form__hint">{errors.email.message}</p>}
                <div className="basic-form__group">
                    <input
                        name="password"
                        placeholder="Password"
                        className="basic-form__text-box"
                        autoComplete="off"
                        ref={register}
                        type="password"
                        disabled={loggingIn}
                    />
                </div>
                {errors.password && <p className="basic-form__hint">{errors.password.message}</p>}
                {formErrors.length !== 0 && <FormErrors errors={formErrors} />}
                <div className="u-display-flex u-align-center">
                    <Button type="submit" primary disabled={loggingIn}>{loggingIn ? 'Logging in...' : 'Login'}</Button>
                </div>

                <p onClick={() => setModalForgotPass(true)} className='link link-underline u-m-top-3'>I've forgotten my password</p>

            </form>

            {
                modalForgotPass && (
                    <Modal closeModal={() => setModalForgotPass(false)}>
                        <ForgotPassword closeModal={() => setModalForgotPass(false)} />
                    </Modal>
                )
            }
        </div>
        
    );
}

export default FranchiseLogin;
